const percent = {
    decimal: ",",
    thousands: ".",
    prefix: "% ",
    suffix: "",
    precision: 2,
    masked: false
}
  
export default percent
